import { USER_PRODUCTS_API } from '../constants/AppConstants';

// #genai includeInternal=true loads external + internal products for filter catalogs
export default async function getUserProducts({ includeInternal = false } = {}) {
  try {
    const url = includeInternal
      ? `${USER_PRODUCTS_API}?includeInternal=true`
      : `${USER_PRODUCTS_API}`;
    const response = await fetch(url);
    const json = await response.json();

    if (response.status !== 200) return { ok: false, json };

    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
}
